export default __webpack_public_path__ + "static/media/NOH_invite-mobile.070e7baf.png";